<template>
  <div>
    <div class="operation_box">
      <div class="operation_item">
        <el-dropdown split-button type="primary" @command="handleCommand">
          <i
            class="fa fa-edit"
            v-if="status === trackPayStats.Rejected"
            @click="handleCommand('edit')"
          ></i>
          <i
            class="fa fa-search-plus"
            v-if="status >= trackPayStats.Submitted && (status < trackPayStats.SentToExternal && status !== trackPayStats.Rejected || status >= trackPayStats.Settled)"
            @click="handleCommand('viewDetail')"
          ></i>
          <i
            class="fa fa-map-marker"
            v-if="status >= trackPayStats.Tracking && status <= trackPayStats.Arrived"
            @click="handleCommand('showTrackingDetail')"
          ></i>
          <i
            class="fa fa-paper-plane"
            v-if="status === trackPayStats.New"
            @click="handleCommand('sendToCustomer')"
          ></i>
          <i
            class="fa fa-ship"
            v-if="status == trackPayStats.SentToExternal ||status == trackPayStats.AllDevicesBound"
            @click="handleCommand('startShipment')"
          ></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in newDropList"
              :key="index"
              :command="item.command"
            >
              <i class="fa" :class="item.icon"></i>
              {{ $t(item.key) }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationUtils} from "@/common/navigation/navigationUtils";

export default {
  data() {
    return {
      currentBtn: "edit",
      dropList: [
        {
          command: "sendToCustomer",
          icon: "fa-paper-plane",
          key: "common.trackAction.sendToCustomer",
          statusList: [enumDef.trackPayStats.New, enumDef.trackPayStats.Rejected]
        },
        {
          command: "startShipment",
          icon: "fa-ship",
          key: "common.trackAction.startShipment",
          statusList: [enumDef.trackPayStats.Transferred, enumDef.trackPayStats.SentToExternal, enumDef.trackPayStats.AllDevicesBound]
        },
        {
          command: "viewDetail",
          icon: "fa-search-plus",
          key: "common.trackAction.viewDetail"
        },
        {
          command: "showTrackingDetail",
          icon: "fa-map-marker",
          key: "common.trackAction.viewTrackingDetail",
          statusList: [enumDef.trackPayStats.Tracking, enumDef.trackPayStats.Arrived, enumDef.trackPayStats.Settled]
        },
        {
          command: "edit",
          icon: "fa-edit",
          key: "common.trackAction.edit",
          statusList: [enumDef.trackPayStats.New, enumDef.trackPayStats.Rejected]
        },
        {
          command: "delContract",
          icon: "fa-trash",
          key: "common.trackAction.delContract",
          statusList: [enumDef.trackPayStats.New]
        },
      ],
      trackPayStats: enumDef.trackPayStats,
    };
  },
  methods: {
    handleCommand(command) {
      if (command === "delContract") {
        this.delContract();
        return;
      }
      if (command === "showTrackingDetail") {
        this.params.showTrackingDetail({
          data: this.params.data,
          btnType: command
        });
        return;
      }
      this.params.showDetail({
        data: this.params.data,
        btnType: command
      });
    },
    delContract() {
      let option = {
        title: this.$t("common.trackAction.delTitle"),
        msg: this.$t("common.trackAction.delTip"),
        confirmFun: () => {
          this.params.delContract(this.params.data.id);
        }
      };
      this.confirmMeg(option, true);
    },
    showDetail() {
      this.params.showDetail({
        data: this.params.data,
        btnType: this.currentBtn,
      });
    },
    requestPutOption() {
      this.$router.push(
        navigationUtils.getRouteWithActiveTab(
          navigationPaths.seller.putOptions,
          navigationTabs.seller.putOptions.requests
        )
      );
    }
  },
  computed: {
    status() {
      return this.params.data.status;
    },
    newDropList() {
      let l = this.dropList;
      l = l.map((item) => {
        item.show = false;
        if (item.command === "viewDetail") {
          item.show = true;
        }
        if (item.statusList && item.statusList.indexOf(this.status) > -1) {
          item.show = true;
        }
        return item;
      });
      l = l.filter((item) => {
        return item.show;
      });
      return l;
    }
  }
};
</script>
